import React from 'react';
import Courses from "../component/courses";

function CoursePage() {
  return (
      <Courses />
  )
}

export default CoursePage;
